export default [
    "Stantec B.V. - Delft, Poortweg 4-d 2612 PA Delft",
    "Stantec B.V. - Arnhem, Tivolilaan 205 6824 BV Arnhem",  
    "Stantec B.V. - Oosterhout, Hoevestein 20-b 4903 SC Oosterhout",
    "Stantec B.V. - Eindhoven, Kastanjelaan 4005616 LZ Eindhoven",
];
